import request from '@/utils/request'

export function getAuthMenu(addIds) {
  return request({
    url: `/usercenter/menus?appIds=${addIds.join('&appIds=')}`,
    method: 'get',
    baseURL: process.env.VUE_APP_MIS_API
  })
}

export function checkTechnical(data) {
  return request({
    url: `/usercenter/user/checkTechnical`,
    method: 'post',
    data,
    baseURL: process.env.VUE_APP_MIS_API
  })
}

export function logout() {
  return request({
    url: '/usercenter/clientapi/login/exit',
    method: 'post',
  })
}

export function userInfo() {
  return request({
    url: '/usercenter/clientapi/getUserDetail',
    method: 'post',
  })
}
